import { API_BASE } from '../configs/Api';
import * as Routes from '../../scripts/routes';

export default class {
  static processar_new_folder_so_processo = async (numero_ano) => {
    const options = {
      method: 'GET',
      url:    Routes.processar_new_folder_so_processo_path(numero_ano)
    };

    return API_BASE(options);
  };

  static processar_update_folder_so_processo = async (numero_ano) => {
    const options = {
      method: 'GET',
      url:    Routes.processar_update_folder_so_processo_path(numero_ano)
    };

    return API_BASE(options);
  };

  static processar_ape_inc_folder_so_processo = async (numero_ano) => {
    const options = {
      method: 'GET',
      url:    Routes.processar_ape_inc_folder_so_processo_path(numero_ano)
    };

    return API_BASE(options);
  };
}
